import React from "react";
import {Button, Col, Row} from "reactstrap";
import * as PropTypes from "prop-types";

const NavButtons = props => (
    <div className={"float-right"}>
        <Button disabled={props.currentQId === 0 || props.loading} onClick={props.onClick}>{"<<"}</Button>
        <input className={"m-1 p-1 text-align-right bg-dark text-white"} type={"text"} readOnly={true} value={(props.currentQId + 1) + "/" + props.numQuestions}/>
        <Button disabled={props.currentResult === -1 || props.currentQId >= props.numQuestions - 1 || props.loading} onClick={props.onClick1}>{">>"}</Button>
    </div>
);

NavButtons.propTypes = {
    currentQId: PropTypes.number,
    loading: PropTypes.any,
    onClick: PropTypes.func,
    numQuestions: PropTypes.any,
    currentResult: PropTypes.any,
    onClick1: PropTypes.func
};

const ResultButton = props => (
    <div className={"float-right"}>
        <Button disabled={props.disabled} className={props.allQuestionsAnswered ? "d-box" : "d-none"} onClick={props.onClick}>Резултати</Button>
    </div>
);

ResultButton.propTypes = {
    disabled: PropTypes.any,
    allQuestionsAnswered: PropTypes.any,
    onClick: PropTypes.func
};
const Navigation = ({testData = {}, currentResult = -1, isAllQuestionsAnswered = false, setCurrentQuestion = f => f, submitResults = f => f, request = {}, isLoading = false}) => (
    <Row className={"q-nav q-nav-buttons"}>
        <Col>
            {
                isAllQuestionsAnswered ?
                    <ResultButton disabled={isLoading} allQuestionsAnswered={isAllQuestionsAnswered} onClick={() => submitResults(request)}/> :
                    <NavButtons currentQId={testData.currentQId} loading={isLoading} onClick={() => setCurrentQuestion(Math.max(0, testData.currentQId - 1))} numQuestions={testData.numQuestions} currentResult={currentResult} onClick1={e => setCurrentQuestion(Math.min(testData.numQuestions - 1, testData.currentQId + 1))}/>
            }
        </Col>
    </Row>
);

export default Navigation